import React from "react";
import "./styles.css";
import logo from "./logo512.png";

function Spinner() {
  return (
    <>
      <div className="spinner-overlay"></div>
      <div className="spinner">
        <img alt="" src={logo} className="logo" loading="eager" />
        <div className="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </>
  );
}

export default Spinner;
